import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const MagicAIWandIcon = (props: any) => {
  // We break the path into a variable to keep the JSX clean
  const pathData = `M7.5 5.6L10 7L8.6 4.5L10 2L7.5 3.4L5 2L6.4 4.5L5 7L7.5
    5.6ZM19.5 15.4L17 14L18.4 16.5L17 19L19.5 17.6L22 19L20.6 16.5L22 14L19.5
    15.4ZM22 2L19.5 3.4L17 2L18.4 4.5L17 7L19.5 5.6L22 7L20.6 4.5L22 2ZM14.38
    5.41C13.99 5.02 13.35 5.02 12.96 5.41L2.41 15.96C2.02 16.35 2.02 16.99 2.41
    17.38L6.62 21.59C7.01 21.98 7.65 21.98 8.04 21.59L18.59 11.04C18.98 10.65
    18.98 10.01 18.59 9.62L14.38 5.41ZM14.5 12.5L11.5 9.5L13.67 7.33L16.67
    10.33L14.5 12.5Z`;

  return (
    <SvgIcon {...props}>
      <defs>
        <linearGradient id="aiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#4285f4', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#9b51e0', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path fill="url(#aiGradient)" d={pathData} />
    </SvgIcon>
  );
};

export default MagicAIWandIcon;



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/MagicWandIcon.tsx